var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ newyear_bg: _vm.theme === 'newyear' }},[_c('Sidebar'),_c('vue-confirm-dialog'),_c('div',{staticClass:"layout__content"},[_c('Header'),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1),_c('Bottom')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }